<app-dialog-heading [heading]="'VivaScore Profile'"></app-dialog-heading>

<ng-container *ngIf="healthData">
  <div class="clearfix overflow-x">
    <div class="col col-12 md-col-6">
      <app-health-score-guage
        [arrowDirection]="ArrowDirection.Up"
        [score]="healthData?.healthScore"
      ></app-health-score-guage>
    </div>
    <div class="col col-12 md-col-5 m-l-25">
      <section class="flex flex-column p3 viva-score-grey-border">
        <div class="flex justify-start items-center">
          <h2>Patient Summary</h2>
        </div>
        <p><b>Legal Reference No:</b> {{ healthData?.legalReferenceNumber ?? 'N/A' }}</p>
        <p><b>Patient ID:</b> {{ healthData?.patientId ?? 'N/A' }}</p>
        <p><b>Health Score ID:</b> {{ healthData?.healthScoreId ?? 'N/A' }}</p>
        <p><b>Benchmark:</b> {{ healthData?.benchmark ?? 'N/A' }}</p>
        <p><b>Total Data Points:</b> {{ healthData?.totalDataPoints ?? 'N/A' }}</p>
        <p><b>Conditions Without Medication:</b> {{ healthData?.conditionsWithoutMedication ?? 'N/A' }}</p>
        <p><b>Conditions With Medication:</b> {{ healthData?.conditionsWithMatchedMedication ?? 'N/A' }}</p>
        <p><b>Next Daily Refresh:</b> {{ healthData?.nextDailyRefresh ?? 'N/A' }}</p>
        <p><b>Next Weekly Refresh:</b> {{ healthData?.nextWeeklyRefresh ?? 'N/A' }}</p>
        <p><b>Next Monthly Refresh:</b> {{ healthData?.nextMonthlyRefresh ?? 'N/A' }}</p>
        <p><b>Disclaimer Message:</b> {{ healthData?.minorDisclaimerMessage ?? 'N/A' }}</p>
      </section>
    </div>
  </div>
  
  <section class="flex flex-column mt3 mb3">
    <div class="clearfix">
      <div *ngIf="healthData?.biometricDataPoints?.length" class="flex justify-end m-r-50">
        <div class="flex justify-center">
          <ng-container *ngFor="let heart of hearts">
            <div class="flex justify-between">
              <app-heart [fillColor]="heart.color" height="20px" width="20px"></app-heart>
              <p class="m-l-5 m-r-5">{{ heart.text }}</p>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="col col-12">
        <app-vivascore-details-overview [healthData]="healthData"></app-vivascore-details-overview>
      </div>
    </div>
  </section>
  
  <!---------------------------->
  <!-- Links Section:-->
  <!---------------------------->
  
  <section class="flex justify-center">
    <app-open-link-as text="About VivaScore"
                      url="https://www.alulatechnologies.com/viva-score">
    </app-open-link-as>
    <app-open-link-as text="VivaScore Disclaimer"
                      url="https://www.alulatechnologies.com/VivaScore_Disclaimer">
    </app-open-link-as>
  </section>
</ng-container>


<div *ngIf="healthData == null" class="center">
  <p>There is no VivaScore profile for this person yet.</p>
  <p>Click the button to retrieve the person's details.</p>
</div>

<mat-dialog-actions align="center" class="dialog-button-container">
  <button (click)="getHealthScoreDetails(basicPersonDetails.personId)"
          [disabled]="disableUpdateButton"
          class="dialog-button" color="primary"
          mat-raised-button>
    Retrieve Score
    <mat-icon *ngIf="disableUpdateButton" class="info-icon"
              matTooltip="Only managers and claims team leaders can manually re-check the person’s score.">
      help_outline
    </mat-icon>
  </button>
</mat-dialog-actions>
